package com.catbit.opinionpoll.core.ui.modifiers

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier

fun Modifier.noBorder(): Modifier {
    return then(this).styleModifier {
        property("border", "none")
    }
}